import React, {useState} from "react";
import { useHistory, useParams } from "react-router";
import {SignalDetail, SignalView } from "@suezenv/signal-widget";
import { HOME_ROUTE } from "../constants/routes";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../store";
import { ISignalCustomParams } from "@suezenv/signal-widget/dist/signal-app/type/signal.type";
import {changeSignalType, SignalType} from "../store/layout/layout.reducer";

const SignalDetailBridge: React.FC = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const userState = useSelector((state: RootState) => state.userReducer);
    const { id } = useParams<{ id: string }>();

    const [customParams,] = useState<ISignalCustomParams>({
        isDisplayCreateRequestAndCloseButton: false,
    } as ISignalCustomParams);

    const displaySignalMap = (lat: string, lon: string): void => {
        dispatch(changeSignalType('map' as SignalType));
        history.push(`/signal/map?lat=${encodeURIComponent(lat)}&lon=${encodeURIComponent(lon)}`);
    };

    return <SignalDetail
        signalId={id}
        user={userState}
        onBackClicked={() => history.push(HOME_ROUTE)}
        goSignalMap={displaySignalMap}
        customParams={customParams}
        customAction={() => {}}
    />;
};

export default SignalDetailBridge;
